/* ═══════════════════════════════════════════════════════════════════════════
   jk-rooms-lots.js — «Показать ещё» у списка «Квартиры списком» страницы
   комнатности ЖК (25.09.2026, слово владельца: «30 строк — много, нужна кнопка»).

   Сервер печатает 10 самых дешёвых квартир группы (components/jk-rooms-lots.php), и
   ровно они в разметке ItemList. Следующие по 10 приезжают ТОЛЬКО по нажатию — тем же
   flat_api.php?action=list&view=flats, что кормит блок квартир (новой точки нет). До
   нажатия их в HTML нет ни скрытыми, ни шаблоном: ни одной ссылки, которую робот
   видит, а человек — нет.

   ⛔ ПОВТОРЫ И ПРОПУСКИ. Серверная выборка группы студий берёт и лоты без комнатности
   (`rooms IS NULL`), а фильтр API — только `rooms = 0`, поэтому «страница 2 по 10» могла
   бы пропустить квартиры. Просим с начала `уже показано + 10` и берём первые 10, которых
   ещё нет в списке. После объединения сортируем строки по цене и номеру: удержанный
   представитель планировки может стоить дороже новой квартиры из другой планировки.

   ⛔ СДВИГ РАСКЛАДКИ (проверка устройств 25.09.2026, P2-1). Строки приезжали через 0,5–3,6 с,
   и всё ниже списка съезжало уже ПОСЛЕ окна «после ввода» (500 мс): телефон 0,21–0,31 CLS за
   нажатие. Поэтому по нажатию СРАЗУ, синхронно, встают заглушки той же высоты (сдвиг внутри
   окна ввода, его CLS не считает), а ответ заменяет их на месте, высота не меняется. Нажатие,
   которое дойдёт до потолка, прячет кнопку тоже сразу — иначе ссылка «Все N квартир» прыгнула
   бы вверх по ответу.

   Сбой сети — заглушки убраны, кнопка «Повторить», список и страница целы.
   ═══════════════════════════════════════════════════════════════════════════ */
(() => {
    'use strict';
    const list = document.querySelector('.jkr-list[data-jkr-more-query]');
    if (!list) return;
    const rows = list.querySelector('.jkr-list__rows');
    const button = list.querySelector('[data-jkr-more]');
    const note = list.querySelector('[data-jkr-more-note]');
    if (!rows || !button) return;

    const step = Number(list.dataset.jkrStep) || 10;
    const max = Number(list.dataset.jkrMax) || 30;
    let total = Number(list.dataset.jkrTotal) || 0;
    const query = list.dataset.jkrMoreQuery || '';
    let busy = false;
    const prices = new Map();

    const idOf = link => {
        const match = /[?&]id=(\d+)/.exec(link.getAttribute('href') || '');
        return match ? match[1] : '';
    };
    const shownIds = () => Array.from(rows.querySelectorAll('a.jkr-list__row')).map(idOf).filter(Boolean);
    const ceiling = () => Math.min(max, total);
    Array.from(rows.querySelectorAll('a.jkr-list__row')).forEach(link => {
        const amount = Array.from(link.children || []).find(child => child.className === 'jkr-list__price');
        const match = /^(\d[\d \u00a0\u202f]*)₽$/.exec(String(amount ? amount.textContent : '').trim());
        const value = match ? Number(match[1].replace(/[ \u00a0\u202f]/g, '')) : NaN;
        if (Number.isFinite(value) && value > 0) prices.set(idOf(link), value);
    });

    const area = value => {
        const n = Math.max(0, Number(value) || 0);
        return n.toFixed(1).replace(/\.0$/, '').replace('.', ',') + ' м²';
    };
    const floor = (value, totalFloors) => {
        const f = Number(value) || 0;
        const t = Number(totalFloors) || 0;
        if (f <= 0) return 'Этаж уточняется';
        return (t >= f ? f + '/' + t : String(f)) + ' этаж';
    };
    const price = value => {
        const n = Math.round(Number(value) || 0);
        return n > 0 ? String(n).replace(/\B(?=(\d{3})+(?!\d))/g, ' ') + ' ₽' : 'Цена по запросу';
    };
    const span = (cls, text) => {
        const el = document.createElement('span');
        el.className = cls;
        el.textContent = text;
        return el;
    };
    // Та же строка, что печатает сервер (components/jk-rooms-lots.php): текст — только
    // через textContent, адрес — канонический flat.php?id=N.
    function row(flat) {
        const li = document.createElement('li');
        const a = document.createElement('a');
        a.className = 'jkr-list__row';
        a.href = '/flat.php?id=' + Number(flat.id);
        const section = String(flat.section || '').trim();
        a.append(
            span('jkr-list__where', floor(flat.floor, flat.floors_total) + (section ? ' · ' + section : '')),
            span('jkr-list__area', area(flat.area)),
            span('jkr-list__price', price(flat.price)),
        );
        li.appendChild(a);
        return li;
    }

    // Сохраняем сами серверные строки и их ссылки, меняется только порядок в списке.
    function sortRows() {
        const ordered = Array.from(rows.children).filter(li => li.firstChild && li.firstChild.className === 'jkr-list__row');
        ordered.forEach(li => {
            const link = li.firstChild;
            const value = prices.get(idOf(link));
            if (value === undefined) return;
            const amount = Array.from(link.children || []).find(child => child.className === 'jkr-list__price');
            if (amount) amount.textContent = price(value);
        });
        ordered.sort((a, b) => {
            const left = idOf(a.firstChild);
            const right = idOf(b.firstChild);
            return ((prices.get(left) ?? Infinity) - (prices.get(right) ?? Infinity)) || Number(left) - Number(right);
        });
        ordered.forEach(li => { li.remove(); rows.appendChild(li); });
    }

    function sync() {
        const count = shownIds().length;
        const done = count >= ceiling();
        button.hidden = done;
        if (!done) button.textContent = 'Показать ещё ' + Math.min(step, ceiling() - count);
    }

    // Заглушка строки: та же рамка и высота, что у настоящей, но НЕ ссылка — ни робот, ни
    // человек не увидят пустого адреса. Высота — замер последней строки (один проход раскладки).
    function placeholder(height) {
        const li = document.createElement('li');
        li.className = 'jkr-list__wait';
        li.setAttribute('aria-hidden', 'true');
        const box = document.createElement('span');
        box.className = 'jkr-list__row jkr-list__row--wait';
        if (height > 0) box.style.height = height + 'px';
        li.appendChild(box);
        return li;
    }
    const waiting = () => Array.from(rows.querySelectorAll('li.jkr-list__wait'));

    function fail() {
        waiting().forEach(li => li.remove());
        button.hidden = false;
        button.textContent = 'Повторить';
        if (note) note.textContent = 'Не удалось загрузить квартиры — проверьте связь и нажмите «Повторить».';
    }

    button.addEventListener('click', () => {
        if (busy) return;
        const have = shownIds();
        const want = Math.min(ceiling(), have.length + step);
        if (want <= have.length) { sync(); return; }
        busy = true;
        const last = rows.querySelector('li:last-child > .jkr-list__row');
        const height = last ? Math.round(last.getBoundingClientRect().height) : 0;
        for (let i = have.length; i < want; i++) rows.appendChild(placeholder(height));
        // Последняя порция: кнопка уйдёт всё равно — пусть уходит сейчас, в окне ввода.
        if (want >= ceiling()) button.hidden = true;
        button.disabled = true;
        button.setAttribute('aria-busy', 'true');
        if (note) note.textContent = '';
        const url = '/flat_api.php?action=list&view=flats&sort=price_asc&page=1&per_page=' + want + '&' + query;
        fetch(url, { credentials: 'same-origin', headers: { Accept: 'application/json' } })
            .then(response => (response.ok ? response.json() : Promise.reject(new Error('HTTP ' + response.status))))
            .then(data => {
                if (!data || data.ok !== true || !Array.isArray(data.flats)) throw new Error('bad payload');
                const seen = new Set(have);
                const fresh = data.flats
                    .filter(flat => {
                        const id = Number(flat && flat.id);
                        const value = Number(flat && flat.price);
                        if (!Number.isSafeInteger(id) || id <= 0 || !Number.isFinite(value) || value <= 0) return false;
                        const key = String(id);
                        prices.set(key, value);
                        if (seen.has(key)) return false;
                        seen.add(key);
                        return true;
                    })
                    .slice(0, want - have.length);
                const first = fresh.length ? row(fresh[0]) : null;
                const waits = waiting();
                // Каждая строка встаёт НА МЕСТО своей заглушки; лишние заглушки уходят.
                fresh.forEach((flat, i) => {
                    const li = i === 0 ? first : row(flat);
                    if (waits[i]) rows.replaceChild(li, waits[i]); else rows.appendChild(li);
                });
                waits.slice(fresh.length).forEach(li => li.remove());
                sortRows();
                // Больше отдать нечего: выдача короче просьбы или новых нет — дальше витрина.
                if (data.flats.length < want || fresh.length === 0) total = shownIds().length;
                sync();
                // Кнопка ушла — фокус на первую новую строку, а не в пустоту.
                if (button.hidden && first) first.firstChild.focus({ preventScroll: true });
            })
            .catch(fail)
            .finally(() => {
                busy = false;
                button.disabled = false;
                button.removeAttribute('aria-busy');
            });
    });

    sync();
})();
